import React from 'react'
import { useCommentData } from './CommentDataContext'
import "./VisibleAllDetails.css";

const VisibleAllDetails = () => {
    const { allVisibleDetails, activeTab } = useCommentData()
    const unit = 1e-6;
    const precesion = 1e-10;
    const dbu = unit / precesion;

    return (
        <div className="all-details-container">
            {allVisibleDetails && allVisibleDetails.length > 0 ? (
                <>
                    <h2 className="total-count">Total number of {activeTab}: {allVisibleDetails.length}</h2>
                    {allVisibleDetails.map((query) => (
                        <div key={query.id} className="query-details">
                            <div className="query-number">{String(activeTab).toLocaleUpperCase()} {query.number}</div>
                            <span className="query-info">User: {query.username}</span>
                            <span className="query-info">
                                Coordinates: ({query.points.x / dbu},{" "}
                                {(query.points.y * -1) / dbu})
                            </span>
                            <span className="query-info">Date: {query.date}</span>
                            <span className="query-info">Time: {query.time}</span>
                            <span className="query-info">Rectangles: {query.rectangle.length}</span>
                            <span className={`query-status ${query.is_resolved ? 'resolved' : 'open'}`}>
                                Status: {query.is_resolved ? 'Resolved' : 'Open'}
                            </span>
                        </div>
                    ))}
                </>
            ) : (
                <div className="query-empty">No visible details available</div>
            )}
        </div>
    )
}

export default VisibleAllDetails